jQuery.noConflict();
jQuery(document).ready(function() {
  if($('.tousprojets').length > 0) {
    // Afficher un nombre limité de projets
    var allitems = ($('.tousprojets_item').length) -1;
    var items = 8;
    if ( allitems > items ) {
      $( '.tousprojets_link' ).show();
    }
    $('.tousprojets_item:lt('+items+')').show();
    // End
    // Lien filtre
    var type = window.location.hash.substr(1);
    if ((type == 'biodiversite') || (type == 'alimentation')) {
      $(".tousprojets_thematique").prop('checked', false);
      $('#'+type).prop('checked', true);
      $( '.tousprojets_link' ).hide();
      $( ".tousprojets_item" ).each(function( index ) {
        if ($(this).data(type)) {
          $(this).show();
        }
        else {
          $(this).hide();
        }
      });
      $( ".tousprojets_item-last" ).show();
    }
    // End
    // Afficher plus en cliquant sur le boutton voir plus
    var i = 1;
    $( '.tousprojets_button' ).click(function() {
      items = items + 9;
      $('.tousprojets_item:lt('+items+')').show();
      if ( items >= allitems ) {
        $( '.tousprojets_link' ).hide();
      }
    });
    // Filtres
    $(".tousprojets_thematique").change(function() {
      $( '.tousprojets_link' ).hide();
      if(this.checked) {
        $( ".tousprojets_item" ).hide();
        $( ".tousprojets_thematique" ).each(function( index ) {
          if(this.checked) {
            var thematique = $(this).attr('id');
            $( ".tousprojets_item" ).each(function( index ) {
              if ($(this).data(thematique)) {
                $(this).show();
              }
            });
          }
        });
      }
      else {
        $(".tousprojets_thematique").prop('checked', true);
        $(this).prop('checked', false);
        $( ".tousprojets_thematique" ).each(function( index ) {
          if(this.checked) {
            var thematique = $(this).attr('id');
            $( ".tousprojets_item" ).each(function( index ) {
              if ($(this).data(thematique)) {
                $(this).show();
              }
              else {
                $(this).hide();
              }
            });
          }
        });
      }
      $( ".tousprojets_item-last" ).show();
    });
  }
});
